"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessagePlaceholders = exports.SubscribedStatus = exports.DeliveryType = void 0;
var DeliveryType;
(function (DeliveryType) {
    DeliveryType["SMS"] = "SMS";
    DeliveryType["MOBILE_PUSH"] = "MOBILE_PUSH";
    DeliveryType["EMAIL"] = "EMAIL";
    DeliveryType["RAWEMAIL"] = "RAWEMAIL";
})(DeliveryType || (exports.DeliveryType = DeliveryType = {}));
var SubscribedStatus;
(function (SubscribedStatus) {
    SubscribedStatus["ACTIVE"] = "ACTIVE";
    SubscribedStatus["SUSPENDED"] = "SUSPENDED";
    SubscribedStatus["POSTPONED"] = "POSTPONED";
})(SubscribedStatus || (exports.SubscribedStatus = SubscribedStatus = {}));
/** @deprecated */
var MessagePlaceholders;
(function (MessagePlaceholders) {
    MessagePlaceholders["TIMESTAMP"] = "TIMESTAMP";
    MessagePlaceholders["TYPE"] = "TYPE";
    MessagePlaceholders["NAME"] = "NAME";
    MessagePlaceholders["GROUP"] = "GROUP";
    MessagePlaceholders["ATTRIBUTE"] = "ATTRIBUTE";
    MessagePlaceholders["VALUE"] = "VALUE";
    MessagePlaceholders["MAX"] = "MAX";
    MessagePlaceholders["MIN"] = "MIN";
    MessagePlaceholders["STANDARD_DEVIATION"] = "STANDARD_DEVIATION";
    MessagePlaceholders["DURATION"] = "DURATION";
    MessagePlaceholders["UNIT"] = "UNIT";
})(MessagePlaceholders || (exports.MessagePlaceholders = MessagePlaceholders = {}));
